import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>D&D Monster Tool</p>
      </div>
    </footer>
  );
}

export default Footer;
